// TODO: rename file to field-of-work-badges.tsx
"use client";

import { useTranslations } from "next-intl";
import type { components } from "@/openapi/generated";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { POPULAR_PROJECT_CATEGORY_ID } from "@/lib/constants";

type FieldOfWorkDto = components["schemas"]["FieldOfWorkDto"];

const VARIANT_STYLES = {
  default: "rounded-md border border-border bg-background px-2 py-0.5 text-xs font-normal text-foreground",
  glass: "rounded-full bg-black/5 dark:bg-black/30 backdrop-blur-sm border border-white/15 dark:border-white/10 px-2.5 py-0.5 text-xs font-medium text-foreground",
} as const;

export default function FieldsOfWorkBadges({
  fields,
  maxBadges = 3,
  variant = "default",
  centered = false,
}: {
  fields: FieldOfWorkDto[]
  maxBadges?: number
  variant?: "default" | "glass"
  centered?: boolean
}) {
  const t = useTranslations("projects");

  const filtered = (fields ?? []).filter((f) => f.id !== POPULAR_PROJECT_CATEGORY_ID);
  if (filtered.length === 0) {
    return <span className="text-sm text-muted-foreground">{t("fieldOfWorkBadges.noneSpecified")}</span>
  }
  const displayedFields = filtered.slice(0, maxBadges)
  const remainderCount = filtered.length - displayedFields.length

  return (
    <div className={cn("flex flex-wrap gap-1.5 mt-1", centered && "justify-center")}>
      {displayedFields.map((fow) => (
        <span
          key={fow.id}
          className={cn("inline-flex items-center", VARIANT_STYLES[variant])}
        >
          {fow.title}
        </span>
      ))}

      {remainderCount > 0 && (
        <Badge variant="outline" className="text-xs font-normal text-muted-foreground">
          {t("fieldOfWorkBadges.moreCount", { count: remainderCount })}
        </Badge>
      )}
    </div>
  )
}
